import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'sr:subawards',
    content: {
      root: {
        elements: [
          {
            height: 800,
            content: {
              widget: {
                widget: {
                  alias: 'sr.subawards.widgets.subawards',
                },
              },
            },
          },
        ],
      },
    },
    description: 'Subawards',
    name: 'Subawards',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
